module.exports = __webpack_public_path__ + "img/WhiteGoogleReview.c6d92779.png";